.field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.select {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--ink);
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 0.5rem 0.625rem;
}

.select:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 1px;
}
